import { alpha } from "@mui/material/styles";

/* ===== Design tokens ===== */
export const BROWN = "#210C03";
export const ACCENT = "#00E5FF";
export const COBALT = "#2D5BFF";

// /* ===== API Endpoints ===== */
export const API_BASE_URLS = {
  dev: "https://api-kaygtiz4kq-uc.a.run.app",
  staging: "https://api-tgxhywdj2a-uc.a.run.app",
  // Keep prod for later, but we won't allow selecting it in UI yet
  prod: "https://api-kaygtiz4kq-uc.a.run.app",
} as const;

/* ===== API Endpoints On Local ===== */
// export const API_BASE_URLS = {
//   dev: "http://127.0.0.1:4001/kinship-thekin/us-central1/api",
//   staging: "http://127.0.0.1:4001/kinship-kinstage/us-central1/api",
//   // Keep prod for later, but we won't allow selecting it in UI yet
//   prod: "http://127.0.0.1:4001/kinship-thekin-76acb/us-central1/api",
// } as const;

export function buildApiUrls(env: "dev" | "staging" | "prod") {
  const base = API_BASE_URLS[env];
  return {
    askUrl: `${base}/ai/ask`,
    patchUrl: `${base}/ai/patch`,
    immediateRcUrl: `${base}/ai/immediate-rc/apply`,
  };
}
export const EMAIL_API_KEY = process.env.REACT_APP_EMAIL_API_KEY || "";

/* ===== Examples ===== */
export const EXAMPLES = [
  "Show all parameters",
  "Force an upgrade",
  "List region conditions",
];

/* ===== Local Storage Keys ===== */
export const LS_KEYS = {
  threadId: "kinshipGPT.threadId",
  messages: "kinshipGPT.messages",
  env: "kinshipGPT.env",
} as const;

/* ===== Animations ===== */
export const pulseKeyframes = {
  "@keyframes cyanPulse": {
    "0%": { boxShadow: `0 0 0 0 ${alpha(ACCENT, 0.0)}` },
    "70%": { boxShadow: `0 0 0 12px ${alpha(ACCENT, 0.12)}` },
    "100%": { boxShadow: `0 0 0 0 ${alpha(ACCENT, 0.0)}` },
  },
};

export const blinkDots = {
  "@keyframes blink": {
    "0%, 80%, 100%": { opacity: 0.25, transform: "translateY(0)" },
    "40%": { opacity: 1, transform: "translateY(-1px)" },
  },
};

/* ===== UI Constants ===== */
export const COMPOSER_HEIGHT = 78;
